import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const TOKEN_KEY = 'valorex_token';
export const ADMIN_TOKEN_KEY = 'valorex_admin_token';

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  // Use admin token for /admin/* routes if present (except admin login flow)
  const isAdmin = (config.url || '').startsWith('/admin/') && !['/admin/login', '/admin/verify-otp'].some((p) => (config.url || '').startsWith(p));
  const token = isAdmin ? localStorage.getItem(ADMIN_TOKEN_KEY) : localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || '';
    if (status === 401) {
      if (url.startsWith('/admin/')) {
        localStorage.removeItem(ADMIN_TOKEN_KEY);
      } else if (!url.startsWith('/auth/login') && !url.startsWith('/auth/register')) {
        localStorage.removeItem(TOKEN_KEY);
      }
    }
    return Promise.reject(err);
  }
);

export default api;
